import { render, staticRenderFns } from "./FullContainer.vue?vue&type=template&id=45fd688b&scoped=true&"
import script from "./FullContainer.vue?vue&type=script&lang=js&"
export * from "./FullContainer.vue?vue&type=script&lang=js&"
import style0 from "./FullContainer.vue?vue&type=style&index=0&id=45fd688b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fd688b",
  null
  
)

export default component.exports